module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "AHD"
  }, [_c('a', {
    attrs: {
      "id": "cupcake"
    }
  }), _vm._v("Cupcake Recipes")]), _vm._v(" "), _c('p', {
    staticClass: "SECTION-INTRO1"
  }, [_vm._v("First, get to know the Golden Rules of Baking before you proceed. I always use a stand mixer and where possible give easy ‘all-in-one’ recipes, but if you wish to make your cake mix by hand, cream the fat and sugar together in a mixing bowl with a wooden spoon until light and fluffy before gradually beating in any liquids and finally incorporating the flour with a large metal spoon.")]), _vm._v(" "), _c('h4', {
    staticClass: "MLAHD"
  }, [_vm._v("Golden rules of baking")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Let all your ingredients come to room temperature before you begin to make your cake mix.")]), _vm._v(" "), _c('li', [_vm._v("Before starting to make your cupcakes, read the recipe right through to familiarize yourself with the method.")]), _vm._v(" "), _c('li', [_vm._v("Preheat your oven and check that it is reaching the correct temperature by using an oven thermometer.")]), _vm._v(" "), _c('li', [_vm._v("Prepare tins (pans) before starting to make your cake mix so that it doesn’t have to sit.")]), _vm._v(" "), _c('li', [_vm._v("Ensure you weigh the ingredients accurately – the key to great cupcakes!")]), _vm._v(" "), _c('li', [_vm._v("Never cream your mixture on full speed – start on slow and work upwards.")]), _vm._v(" "), _c('li', [_vm._v("Eggs are best used when they are at room temperature.")]), _vm._v(" "), _c('li', [_vm._v("Add eggs one at a time or gradually to prevent curdling, adding a tablespoon of the flour if it looks like the mixture may be starting to curdle.")]), _vm._v(" "), _c('li', [_vm._v("Always fold in the flour. If using a mixer, use the paddle attachment (flat beater) on the slowest speed.")]), _vm._v(" "), _c('li', [_vm._v("Generally fill the muffin baking cases (liners) two-thirds full for a flat top and to allow room for frosting.")]), _vm._v(" "), _c('li', [_vm._v("If your oven has a hot spot, rotate the pan halfway through baking.")]), _vm._v(" "), _c('li', [_vm._v("Use a wire rack to help your cakes cool quickly.")])]), _vm._v(" "), _c('div', {
    staticClass: "SBDIV"
  }, [_c('h4', {
    staticClass: "SbS-AHD"
  }, [_vm._v("Cupcake troubleshooting")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_c('strong', [_vm._v("Peaked")]), _vm._v(" – either too much raising agent or the oven temperature is too hot")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_c('strong', [_vm._v("Sunken")]), _vm._v(" – not cooked for long enough or oven door opened too soon")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_c('strong', [_vm._v("Sloping")]), _vm._v(" – check with a spirit level that your oven shelves or even the oven itself is level")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_c('strong', [_vm._v("Some cooked but others not quite")]), _vm._v(" – your oven may have a hot spot, so the muffin tray (pan) needs to be rotated halfway through the cupcake baking time")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_c('strong', [_vm._v("Dense or heavy texture")]), _vm._v(" – mixture not thoroughly mixed together and the raising agent hasn’t been distributed evenly; can also be caused by overbeating the mixture")])]), _vm._v(" "), _c('div', {
    staticClass: "SBDIV"
  }, [_c('h4', {
    staticClass: "SbS-AHD"
  }, [_vm._v("US cup measurements")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_vm._v("If you prefer to use cup measurements, please use the following conversions.")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_vm._v("(Note: 1 Australian tbsp = 20ml.)")]), _vm._v(" "), _c('h5', {
    staticClass: "SbS-BHD"
  }, [_vm._v("Liquid")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_vm._v("1 tsp = 5ml")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_vm._v("1 tbsp = 15ml")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v(" cup = 120ml/4fl oz")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_vm._v("1 cup = 240ml/8"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("fl oz")]), _vm._v(" "), _c('h5', {
    staticClass: "SbS-BHD"
  }, [_vm._v("Butter")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_vm._v("1 tbsp = 15g/"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("oz")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_vm._v("2 tbsp = 25g/1oz")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v(" cup/1 stick = 115g/4oz")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_vm._v("1 cup/2 sticks = 225g/8oz")]), _vm._v(" "), _c('h5', {
    staticClass: "SbS-BHD"
  }, [_vm._v("Caster (superfine) sugar/brown sugar")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v(" cup = 100g/3"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("oz")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_vm._v("1 cup = 200g/7oz")]), _vm._v(" "), _c('h5', {
    staticClass: "SbS-BHD"
  }, [_vm._v("Icing (confectioners’) sugar")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_vm._v("1 cup = 115g/4oz")]), _vm._v(" "), _c('h5', {
    staticClass: "SbS-BHD"
  }, [_vm._v("Flour")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_vm._v("1 cup = 125g/4"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("oz")]), _vm._v(" "), _c('h5', {
    staticClass: "SbS-BHD"
  }, [_vm._v("Ground almonds")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v(" cup = 50g/1"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("3")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("oz")]), _vm._v(" "), _c('h5', {
    staticClass: "SbS-BHD"
  }, [_vm._v("Chopped nuts")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_vm._v("1 cup = about 125g (4"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("oz)")]), _vm._v(" "), _c('h5', {
    staticClass: "SbS-BHD"
  }, [_vm._v("Cream cheese")]), _vm._v(" "), _c('p', {
    staticClass: "BOX1"
  }, [_vm._v("1 cup = 225g (8oz)")])]), _vm._v(" "), _c('div', {
    staticClass: "SBDIV"
  }, [_c('p', {
    staticClass: "TIP1"
  }, [_vm._v("Any baked but undecorated cupcakes can either be frozen for a treat another day (up to a month in an airtight box) or used to create cake pops – see Bake Me I’m Yours… Cake Pops for ideas.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b69b12b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c03.vue
// module id = 72
// module chunks = 0